import React from 'react';
import './DashboardTablePage.css';
import Sidebar from '../../components/sidebar/Sidebar';
import AddNewInputTypeFormForAll from "../../components/pageManager/AddNewInputTypeFormForAll";

const DynamicInputPage = () => {
    return (
        <div className={"dashboard-page"}>
            <div className="dashboard-bggg">
                <div className="dashboard-flex-containerr">
                    <Sidebar />
                    <AddNewInputTypeFormForAll />
                </div>
            </div>
        </div>
    );
};

export default DynamicInputPage;
